export const MISSIVE_CHAT_ID = process.env.missiveChatId

export const MISSIVE_SCRIPT_URL = `https://webchat.missiveapp.com/${MISSIVE_CHAT_ID}/missive.js`

// last message exchanged with us. While it is fresh we load the widget up front (not open
// it), so an agent's reply is visible without the visitor clicking first
export const CHAT_LAST_MESSAGE_STORAGE_KEY = 'trama-chat-last-message'

// the panel was open when the visitor last left, so we reopen it on their next page load
export const CHAT_LEFT_OPEN_STORAGE_KEY = 'trama-chat-left-open'

// how long we treat conversation as active. Window slides on every message,
// so it only expires on a conversation that has actually gone quiet
export const CHAT_ACTIVE_WINDOW_MS = 7 * 24 * 60 * 60 * 1000 // 7 days
